import { render } from "./Histories.vue?vue&type=template&id=4911ee6b"
import script from "./Histories.vue?vue&type=script&lang=js"
export * from "./Histories.vue?vue&type=script&lang=js"
script.render = render

export default script